export class QualityControlMechanical {
    id!: string
    job!: string
    boltNutWasherMaterialType!: string
    highTorqueRequired!: string
    flangeTypeRequired!: string
    createdOn!: Date
    modifiedOn!: Date
}
